import { Button, ButtonProps } from '../button';
import Loader from '../loader';

export interface ButtonWithLoaderProps extends ButtonProps {
  isLoading?: boolean;
}

const ButtonWithLoader = (props: ButtonWithLoaderProps) => {
  const { isLoading = false, ...buttonProps } = props;
  return (
    <>
      {isLoading ? (
        <Button {...buttonProps}>
          <Loader />
        </Button>
      ) : (
        <Button {...buttonProps} />
      )}
    </>
  );
};

export default ButtonWithLoader;
